<div id="query-selected-overview-tab-wrapper">
  <div id="code-editor">
    <div class="tool-bar">
      <hyperkit-button
        size="small"
        color="secondary"
        icon="copy"
        text="Copy"
        (click)="copyQuery()"
      ></hyperkit-button>

      <!-- View unedited/original -->
      <hyperkit-button
        size="small"
        color="secondary"
        text="View Original"
        (click)="viewOriginal()"
      ></hyperkit-button>
      @if (!isPivot() && huntView.huntTemplateId()) {
        <hyperkit-button
          size="small"
          color="secondary"
          icon="save"
          text="Save To Template"
          [disabled]="!huntView.huntTemplateId()"
          (click)="saveToTemplate()"
        ></hyperkit-button>
      }

      <!-- Revert to last‐saved / original -->
      <hyperkit-button
        size="small"
        color="secondary"
        icon="rewind"
        text="Revert"
        [disabled]="
          !selectedQuery() || rawQuery() === queryView.originalQuery()
        "
        (click)="revertToOriginal()"
      ></hyperkit-button>

      <!-- Open in external tool (if supported) -->
      @if (
        queryView.selectedToolType() &&
        queryView.selectedTool()?.rootUrl?.trim()
      ) {
        <hyperkit-link
          size="sm"
          color="primary"
          variant="emphasized"
          size="md"
          text="Open in Tool"
          (click)="trackOpenInTool()"
          [href]="getToolSearchUrl(queryView.selectedTool()!, rawQuery())"
          target="_blank"
        ></hyperkit-link>
      }
    </div>

    <!-- Main code editor -->
    <hyperkit-code-editor
      [value]="rawQuery()"
      (valueChange)="rawQuery.set($event)"
      [options]="{ language: 'json' }"
    >
    </hyperkit-code-editor>
    <div class="tool-bar">
      <hyperkit-button
        (click)="toggleTuning()"
        size="small"
        variant="standard"
        text="Tune"
        icon="filter"
        [color]="nav.showTuning() ? 'tertiary' : 'secondary'"
      ></hyperkit-button>
      @if (supportedPivot && huntCategory()) {
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          icon="shuffle"
          iconPosition="left"
          text="Pivot"
          (click)="onPivot()"
        ></hyperkit-button>
      }
    </div>
  </div>

  <!-- Notes editor -->
  <div id="outcome-notes">
    <hyperkit-typography variant="h5">Query Notes</hyperkit-typography>
    <hyperkit-editor
      [value]="formattedNotes()"
      (valueChange)="formattedNotes.set($event)"
    ></hyperkit-editor>
  </div>
</div>
